import EnvConfig from 'env.config';

export const EULA_ACCEPTED = 'EULA_ACCEPTED';

function accept() {
  return {
    type: EULA_ACCEPTED
  };
}

export function acceptEula(setCookie) {
  return (dispatch) => {
    if (setCookie) {
      document.cookie = `${ EnvConfig.eulaCookieName }=true; path=/; expires=${ new Date(2147483647 * 1000).toUTCString() }; samesite=lax`;
    }
    dispatch(accept());
  };
}
